import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, ArrowRight, CheckCircle, Smartphone, CreditCard } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carlos Mendoza',
    role: 'Redactor Freelance',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    quote: 'Estaba escéptico, pero usé los comandos del bono para redactar un artículo y conseguí mi primer cliente internacional. Para alguien en Venezuela, lograr esto copiando y pegando te cambia la perspectiva.'
  }, {
    name: 'Ana Pereira',
    role: 'Madre y Emprendedora',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=faces',
    quote: 'Pensé que mi teléfono viejo no serviría. Pero como todo es por internet, no tuve que descargar nada pesado. Ya conseguí mis primeros dos clientes fijos y trabajo desde la sala de mi casa.'
  }, {
    name: 'David López',
    role: 'Asistente Virtual',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=faces',
    quote: 'Pagué el Masterkit facilito con Pago Móvil y me llegó al correo al instante. Además, la guía de herramientas gratuitas me ahorró tener que pagar suscripciones costosas.'
  }, {
    name: 'Elena Torres',
    role: 'Ex-Docente',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    quote: 'Mi sueldo en bolívares no daba para más. Ahora hago resúmenes y traducciones con IA en mis ratos libres y genero un ingreso extra que me da muchísima tranquilidad.'
  }, {
    name: 'Javier Costa',
    role: 'Diseñador Principiante',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    quote: 'Cero experiencia previa. La Biblia de Prompts es oro puro. Solo le doy la instrucción a la IA y le entrego gráficos increíbles a mis clientes de España. Se pagó solo el primer día.'
  }, {
    name: 'Mariana Ruiz',
    role: 'Estudiante',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=faces',
    quote: 'Dejé de estresarme por la devaluación. Saber que tengo una habilidad global muy buscada, y que puedo trabajar 2 horas al día, me dio la seguridad que necesitaba.'
  }];
  return <section className="py-24 bg-[#050505] relative overflow-hidden" data-id="element-263">
      {/* Fondo decorativo */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-5xl h-full bg-cyan-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-264" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-265">
        {/* Encabezado */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-266">
          <motion.h2 initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black text-white mb-6 tracking-tight" data-id="element-267">
            VENEZOLANOS QUE YA{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-500 drop-shadow-[0_0_15px_rgba(34,211,238,0.3)]" data-id="element-268">
              DIERON EL SALTO
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-400 font-light" data-id="element-269">
            Únete a cientos de personas que ya blindaron su economía trabajando
            a nivel global.
          </motion.p>
        </div>

        {/* Grid Perfecta de 3 Columnas x 2 Filas */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20" data-id="element-270">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="relative p-8 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-cyan-500/40 hover:bg-white/[0.06] transition-all duration-300 group flex flex-col h-full shadow-lg" data-id="element-271">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-white/5 group-hover:text-cyan-500/20 transition-colors duration-500" data-id="element-272" />

              <div className="flex gap-1 mb-6" data-id="element-273">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-274" />)}
              </div>

              <p className="text-base md:text-lg text-gray-300 mb-8 italic leading-relaxed flex-grow font-light" data-id="element-275">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4 border-t border-white/5 pt-6 mt-auto" data-id="element-276">
                <div className="relative" data-id="element-277">
                  <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white/10 group-hover:border-cyan-500 transition-colors duration-300" data-id="element-278">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" data-id="element-279" />
                  </div>
                  <div className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-0.5 border-2 border-[#050505]" data-id="element-280">
                    <CheckCircle className="w-3 h-3 text-white" data-id="element-281" />
                  </div>
                </div>
                <div data-id="element-282">
                  <h4 className="font-bold text-white text-sm" data-id="element-283">{t.name}</h4>
                  <p className="text-cyan-400 text-xs font-bold uppercase tracking-wider" data-id="element-284">
                    {t.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* CTA FINAL DE ALTO IMPACTO */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative max-w-4xl mx-auto mt-24 p-1 rounded-3xl bg-gradient-to-r from-cyan-500 via-blue-600 to-purple-600 shadow-[0_0_40px_-10px_rgba(34,211,238,0.5)]" data-id="element-285">
          <div className="bg-[#0a0a0a] rounded-[22px] p-8 md:p-12 text-center overflow-hidden relative" data-id="element-286">
            {/* Brillo de fondo */}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-blue-500/10 to-transparent pointer-events-none" data-id="element-287" />

            <h3 className="text-2xl md:text-4xl font-black text-white mb-4 relative z-10 tracking-tight" data-id="element-288">
              ¿Listo para empezar a{' '}
              <span className="text-cyan-400" data-id="element-289">trabajar globalmente</span>?
            </h3>
            <p className="text-gray-400 mb-8 max-w-2xl mx-auto relative z-10 font-light text-base md:text-lg" data-id="element-290">
              El precio subirá pronto. Aprovecha el descuento de lanzamiento y
              llévate el Masterkit + Todos los Bonos hoy.
            </p>

            {/* BOTÓN CON ENLACE AL CHECKOUT Y PRECIO EN BS */}
            <a href="https://checkout.digitalsolvex.shop/cart/43743678496856:1?checkout" target="_blank" rel="noopener noreferrer" className="relative z-10 inline-block w-full md:w-auto group" data-id="element-291">
              <button className="px-8 py-4 w-full md:w-auto rounded-full bg-white text-black font-black text-lg md:text-xl transition-all flex flex-col items-center justify-center gap-1 mx-auto cursor-pointer relative overflow-hidden group-hover:scale-[1.02] group-hover:shadow-[0_0_30px_rgba(6,182,212,0.5)]" data-id="element-292">
                <div className="flex items-center gap-3" data-id="element-293">
                  DESCARGAR PACK AHORA
                  <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-294" />
                </div>
                <span className="text-sm font-bold text-gray-700 bg-gray-100 px-3 py-1 rounded-full mt-1" data-id="element-295">
                  Paga $14.99 o Aprox. Bs. 7.150
                </span>
              </button>
            </a>

            {/* TRUST BADGES FINALES */}
            <div className="mt-8 flex flex-col items-center gap-3 relative z-10" data-id="element-296">
              <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-sm w-full" data-id="element-297">
                <span className="flex items-center justify-center gap-2 text-green-400 bg-green-500/10 px-4 py-2 rounded-xl border border-green-500/30 flex-1 min-w-[130px] max-w-[180px]" data-id="element-298">
                  <Smartphone className="w-5 h-5" data-id="element-299" /> Pago Móvil
                </span>
                <span className="flex items-center justify-center gap-2 text-yellow-400 bg-yellow-500/10 px-4 py-2 rounded-xl border border-yellow-500/30 flex-1 min-w-[130px] max-w-[180px]" data-id="element-300">
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-301">
                    <path d="M11.999 0L17.58 5.582l-2.028 2.028-3.553-3.553-3.553 3.553-2.028-2.028L11.999 0zm0 16.516l-4.516-4.516-2.028 2.028 6.544 6.544 6.544-6.544-2.028-2.028-4.516 4.516zm9.58-10.934l2.028 2.028-6.544 6.544-2.028-2.028 6.544-6.544zm-19.16 0l2.028-2.028 6.544 6.544-2.028 2.028-6.544-6.544z" data-id="element-302" />
                  </svg>{' '}
                  Binance Pay
                </span>
                <span className="flex items-center justify-center gap-2 text-blue-400 bg-blue-500/10 px-4 py-2 rounded-xl border border-blue-500/30 flex-1 min-w-[130px] max-w-[180px]" data-id="element-303">
                  <CreditCard className="w-5 h-5" data-id="element-304" /> Tarjetas
                </span>
              </div>
            </div>

            <p className="mt-6 text-sm text-gray-500 flex items-center justify-center gap-2 relative z-10 font-medium" data-id="element-305">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-306" />
              Entrega automática e inmediata a tu correo electrónico
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}